import { UserAccountType } from "@common/constants";

export const BETTING_TYPE_ACCOUNTS_ABRV = [
	UserAccountType.SportBettingAccountOnline,
	UserAccountType.SportBettingAccountShopOnline,
	UserAccountType.CashToDigitalAccount,
	UserAccountType.SportBettingAccountShop,
];
